import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  title: {
    fontFamily: "MontserratBold",
    fontStyle: "normal",
    fontWeight: 700,
    textAlign: "center",
    color: theme.palette.text.nonary,
    "@media screen and (min-width:576px)": {
      fontSize: "30px",
      lineHeight: "1.4",
    },
    "@media screen and (max-width:992px)": {
      fontSize: "24px",
      lineHeight: "1.35",
    },
  },

  link: {
    textDecoration: "none",
  },
  containerMoreInformationDemo: {
    marginTop: 10,
    marginBottom: "50px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    "@media screen and (width: 1024px) and (height: 600px)": {
      marginTop: 50,
    },
    "@media screen and (width: 1280px) and (height: 800px)": {
      marginTop: 50,
    },
    "@media (max-resolution: 1.1dppx), (max-device-pixel-ratio: 1.1)": {
      marginTop: 50,
    },
  },
}));

export default useStyles;
